var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdb-row',[_c('mdb-col',{attrs:{"md":"2"}},[_c('vertical-list',{attrs:{"titles":_vm.routes.titles,"active":_vm.current},on:{"select-item":_vm.onSelectItem}})],1),_c('mdb-col',{attrs:{"md":"10"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }